import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterState } from './router.interfaces';

export const getRouterReducerState = createFeatureSelector<RouterState>('router');
export const getCurrentRoute = createSelector(getRouterReducerState, (routerReducerState) => routerReducerState?.state);
